import Reflux from 'reflux';

export default Reflux.createActions(['showDetails', 'collapse', 'expand']);
